import React from 'react'
import { connect } from 'react-redux'
import { UserHelper } from "../Classes/UserHelper";
import {
    ajaxFeedback,
    ajaxUpdateFeedbackStatus,
    clearMaskedCallProxy,
    findWithAttr,
    getChatIcons,
    getDepartmentFilter,
    getRatingsFilter,
    getStarsJSX,
    getTagFilter,
    reviewLinkSent,
    secondsToBriefDhms,
    setSelectedFeedback,
    updateCheckedFeedbacks,
    updateModalContent
} from '../redux/FeedbackRedux'
import Smiley from '../Smiley'

class Feedback extends React.Component {
    constructor(props) {
        super(props);
        const intervalObject = setInterval(() => {
            this.setState({ ...this.state, timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted() });
        }, 1000);

        this.state = {
            timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted(),
            intervalObject
        };
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalObject);
    }

    componentDidMount() {
        // Get all feedback description elems of each feedback row
        const parents = document.querySelectorAll('.feedback-card-v2');

        parents.forEach(parent => {
            // Get the span and b elements within the parent
            const span = parent.querySelector('.feedback-card-v2-description');
            const bold = parent.querySelector('.feedback-card-v2-description b');

            if (span && bold && bold.offsetHeight > span.offsetHeight) {
                span.setAttribute('data-toggle', 'tooltip');
                span.setAttribute('data-placement', 'bottom');
            }
        });

        // FIX RTF-3595: Hide tooltip on feedback list update while tooltip is active.
        if (document.querySelector('.tooltip')) {
            $('.tooltip').tooltip('hide');
        }
    }

    getBadgeType(status) {
        let badgetype = "badge-primary";
        switch (status) {
            case window.feedbackStatus.Resolved.value:
                badgetype = "badge-success";
                break;
            case window.feedbackStatus.Pending.value:
                badgetype = "badge-warning"
                break;
        }
        return badgetype;
    }

    updateChecked() {
        this.props.dispatch(updateCheckedFeedbacks(this.props.feedback.id));
    }

    handleClick() {
        if (this.props.state.isDashboard)
        {
            window.open(`/feedback/${this.props.feedback.id}/detail`, "_blank")
            return;
        }
        this.props.dispatch(clearMaskedCallProxy());
        event.preventDefault();
        this.props.dispatch(setSelectedFeedback(this.props.feedback.id));
        this.props.dispatch(ajaxFeedback(this.props.feedback.id));

        // clear tooltip on feedback click
        jQuery('[data-toggle="tooltip"]').tooltip('hide');
    }

    handleTimeSinceFeedBackStarted() {
        if (!this.props.feedback.timeStart) return "";
        const startDate = new Date(this.props.feedback.timeStart);
        const endDate = new Date();
        const seconds = (+endDate - +startDate) / 1000;

        return secondsToBriefDhms(seconds, false, true);
    }

    handleStatusClick(event) {
        event.stopPropagation();
        event.preventDefault();
        var status = jQuery(event.target).attr('id');
        var hide_chat_modal = false;
        var hide_notes_modal = false;
        var hide_review_modal = false;

        if (this.props.feedback.custom_qr_code) {
            hide_chat_modal = this.props.feedback.custom_qr_code.hide_chat_modal;
            hide_notes_modal = this.props.feedback.custom_qr_code.hide_notes_modal;
            hide_review_modal = this.props.feedback.custom_qr_code.hide_review_modal;
        }
        if (status !== this.props.feedback.status) {
            var id = this.props.feedback.id;

            if (status === window.feedbackStatus.Open.value) {
                this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))

            } else if (status === window.feedbackStatus.Resolved.value) {
                // if warnIfNoReviewLinkSent is checked don't show modal
                if (!this.props.state.business.options?.warn_if_no_review_link_sent) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
                    return;
                }

                if (this.props.feedback.is_text === 0 && this.props.feedback.is_whatsapp === 0) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
                    return;
                }

                if (
                    (this.props.feedback.chats_count == 0 || this.props.feedback.chats_count == null)
                    && this.props.feedback.is_text == 1
                    && !hide_chat_modal
                ) {
                    var modal_type = 'm3';
                    var modal_id = "statusModal";
                    var modal_title = __("Update Status");
                    var modal_body = __("You are marking a Feedback as 'Resolved' where a chat/text response has been requested but no chat has been initiated by an employee. If the issue has been resolved, please consider sending them a chat to let them know, or consider adding notes to the system detailing how the feedback was resolved.");
                    var button_1_class = "primary";
                    var button_1_id = "cancel";
                    var button_1_text = __("Cancel - I'll send them a chat");
                    var button_2_class = "outline-primary";
                    var button_2_id = "setResolved";
                    var button_2_text = __("Continue without sending a chat");
                    this.props.dispatch(updateModalContent({
                        modal_type: modal_type,
                        modal_id: modal_id,
                        modal_title: modal_title,
                        modal_body: modal_body,
                        button_1_class: button_1_class,
                        button_1_id: button_1_id,
                        button_1_text: button_1_text,
                        button_2_class: button_2_class,
                        button_2_id: button_2_id,
                        button_2_text: button_2_text,
                        selected_feedback_modal: this.props.feedback }));
                    jQuery('.modal:not(.error)').modal();
                } else if (
                    (this.props.feedback.chats_count == 0 || this.props.feedback.chats_count == null)
                    && !this.props.feedback.is_text
                    && this.props.feedback.notes.length == 0
                    && !hide_notes_modal
                ) {
                    var modal_id = "statusModal";
                    var modal_title = __("Update Status");
                    var modal_body = 'You are marking a Feedback as "Resolved" without any including any details about why it is being closed out. We encourage you to add notes to the Feedback detailing how it was resolved.';
                    var button_1_class = "primary modal-add-notes-button";
                    var button_1_id = "cancel";
                    var button_1_text = __("Cancel - I'll add notes");
                    var button_2_class = "outline-primary";
                    var button_2_id = "setResolved";
                    var button_2_text = __("Continue without adding notes");
                    this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text, selected_feedback_modal: this.props.feedback }));
                    jQuery('.modal:not(.error)').modal();
                } else if (
                    (this.props.feedback.chats_count == 0 || this.props.feedback.chats_count == null)
                    && !this.props.feedback.is_text
                    && this.props.feedback.notes == 0
                    && !hide_notes_modal
                ) {
                    var modal_type = 'm3';
                    var modal_id = "statusModal";
                    var modal_title = __("Update Status");
                    var modal_body = 'You are marking a Feedback as "Resolved" without any including any details about why it is being closed out. We encourage you to add notes to the Feedback detailing how it was resolved.';
                    var button_1_class = "primary modal-add-notes-button";
                    var button_1_id = "cancel";
                    var button_1_text = __("Cancel - I'll add notes");
                    var button_2_class = "outline-primary";
                    var button_2_id = "setResolved";
                    var button_2_text = __("Continue without adding notes");
                    this.props.dispatch(updateModalContent({ modal_type: modal_type, modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text, selected_feedback_modal: this.props.feedback }));
                    jQuery('.modal:not(.error)').modal();
                } else if (
                    (this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == "1")
                    && false === reviewLinkSent(this.props.feedback.chats)
                    && this.props.feedback.business.rating_request === 1
                    && this.props.feedback.is_text === 1
                    && (this.props.feedback.rating_page_id === null && this.props.feedback.access_method !== 'AutoPilot SMS')
                    && !hide_review_modal
                ) {
                    var modal_id = "statusModal";
                    var modal_title = __("Update Status");
                    var modal_body = __("You are marking a Feedback as 'Resolved' where a Review Request link has not yet been sent to the Feedbacker in chat. If the issue has been resolved, please consider sending them the Review Request link in chat. ");
                    var button_1_class = "primary";
                    var button_1_id = "cancel";
                    var button_1_text = __("Cancel - I'll send them a review request link");
                    var button_2_class = "outline-primary";
                    var button_2_id = "setResolved";
                    var button_2_text = __("Continue without sending the link");
                    this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text, selected_feedback_modal: this.props.feedback }));
                    jQuery('.modal:not(.error)').modal();

                } else {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
                }

            } else if (status === window.feedbackStatus.Pending.value) {
                var index = findWithAttr(this.props.feedback.pendingreminders, "hashed_user_id", this.props.state.current_user);
                if (index !== false) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
                } else {
                    var modal_id = "pendingModal";
                    var modal_title = __("Update Status");
                    var modal_body = "pendingModal"
                    var button_1_class = "outline-primary";
                    var button_1_id = "cancel";
                    var button_1_text = __("Cancel");
                    var button_2_class = "outline-primary";
                    var button_2_id = "setPending";
                    var button_2_text = __("Continue without setting a reminder");
                    this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text, selected_feedback_modal: this.props.feedback }));
                    jQuery('.modal:not(.error)').modal();
                }
            } else if (status === window.feedbackStatus.RatingsOnly.value) {
                this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
            }
        }
    }

    render() {
        const feedback = this.props.feedback;

        let badgetype = this.getBadgeType(feedback.status);
        let priorityClass = "priority-" + feedback.priority;
        let priorityTextClass = feedback.priority === 30 ? 'text-priority-30' : '';
        let iconList = getChatIcons(feedback, "");
		let stars = getStarsJSX(feedback.ratethisbiz_rating, "OTF", true);
        let createdAtElements = feedback.created_at.split(" ");
        let lastChat = feedback && feedback.chats ? feedback.chats[feedback.chats.length - 1] : null;

        const regex = new RegExp(this.props.state.query, "gi");
        let AIScore = "";
        if (feedback.sentiment_score) {
            AIScore = feedback.sentiment_score != 0 ? ((((feedback.sentiment_score.score + 1) / 2) * 100).toFixed(0) + "%") : "";
        }

        // console.log(feedback, lastChat);

        const smileyrating =
            <div className="feedback-rating-satisfaction-wrapper" data-withstars={feedback.ratethisbiz_rating > 0}>
                <div style={{ "lineHeight": "20px" }} className="algin-items-center d-flex">
                    <span data-toggle="tooltip" data-placement="top" data-title={__('A Feedback\'s smiley rating is chosen by the Feedbacker when they submit the Feedback. The ratings are color-coded as follows unhappiest to happiest:') + ": <img src='/img/feedback-smiley-rating-scale.png' style='width:100%; border-radius: 5px;' />"} >
                        <Smiley is_feedback_detail={true} smiley_score={this.props.feedback.smiley_score} secondMode AIScore={AIScore} />
                    </span>
                    {AIScore &&
                        <span data-toggle="tooltip" data-placement="top" data-title={__("A Feedback's AI (Artificial Intelligence) Score is determined by algorithms that rate the sentiment of the initial Feedback left by the Feedbacker.  The higher the score (0-100) the more satisfied the Feedbacker is assumed to be.")} >{__('AI Sentiment')}: {AIScore}</span>
                    }
                </div>
                {feedback.ratethisbiz_rating > 0 &&
                    <div className="feedback-stars-rating" data-toggle="tooltip" data-placement="top" data-title={"This is the star rating submitted by the customer after receiving the 1Thru5 Link. This is a private site owned by Feedback and this rating is not made public."}>
                        {stars}
                    </div>
                }
            </div>;

        const business_row_name = feedback.business ?  <span className="col-1 pl-0 feedback-card-v2-name">{feedback.business.alt_name ||feedback.business.name}</span> : "";

        return (
            <>
                <div className={"d-xl-none feedback-card-v2-m priority mb-2 cursor-pointer " + priorityClass}
                    data-priority={feedback.priority} onClick={this.handleClick.bind(this)}>
                    <div className={'feedback-card-v2-m-wrapper d-flex'}>
                        <div>
                            {this.props.state.title !== "More" && !this.props.state.isDashboard &&
                                <input type="checkbox" className="feedback-card-v2-checkbox mr-2 mt-1"
                                    onChange={this.updateChecked.bind(this)}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                    }}
                                    checked={this.props.state.checked_feedbacks.includes(feedback.id)} />}
                        </div>
                        <div className={'feedback-card-v2-m-content d-flex'}>
                            <div className="d-flex justify-content-between">
                                <span className="feedback-card-v2-m-name">{feedback.name}</span>
                                <div className="mr-2">{smileyrating}</div>
                            </div>

                            {/* mobile: department */}
                            {this.props.state.businessDepartmentCount > 0 &&
                                <b className="feedback-card-v2-m-department">
                                    {feedback.department}
                                </b>
                            }
                            {/* mobile: origin */}
                            {feedback?.referrer?.label?.length > 0 &&
                                <span className="feedback-card-v2-m-department">
                                    <span>{feedback?.referrer?.label}</span> {feedback?.referrer?.link?.label && "-"} <span>{feedback?.referrer?.link?.label}</span>
                                </span>
                            }
                        </div>

                        {/* mobile: status */}
                        <div className="col-1 pl-0 w-100 feedback-card-v2-badge text-center">
                            <span
                                className={"badge badge-pill w-100 p-0 " + badgetype}
                                id="dropdownMenuButtonMobile"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                onClick={(event) => {event.stopPropagation();}}
                            >
                                {window.feedbackStatus[feedback.status].label}
                            </span>

                            <div className="mt-3">
                                {iconList}
                            </div>

                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButtonMobile" onClick={(event) => {
                                event.stopPropagation();
                            }}>
                                <a className="dropdown-item" id={window.feedbackStatus.Open.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Open.label}</a>
                                <a className="dropdown-item" id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Pending.label}</a>
                                <a className="dropdown-item" id={window.feedbackStatus.Resolved.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Resolved.label}</a>
                                {this.props.state.businessHasAutoPilot && feedback.ratethisbiz_rating && !feedback.description ? (<a className="dropdown-item" id={window.feedbackStatus.RatingsOnly.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.RatingsOnly.label}</a>) : null}
                            </div>
                        </div>


                    </div>

                    {/* mobile: feedback description */}
                    <div className={'feedback-card-v2-m-details'}>
                        <p className="text-primary feedback-card-v2-m-description">
                            { this.props.state.isDashboard
                                ?
                                    <b>
                                        {feedback.attachment_count > 0 &&
                                            <i className="fas fa-paperclip feedback-icon-thin" data-search="attach attachment connect link paperclip"></i>
                                        }
                                        {feedback.description}
                                    </b>
                                :
                                    <b className={priorityTextClass}>
                                        {feedback.attachment_count > 0 &&
                                            <i className="fas fa-paperclip feedback-icon-thin" data-search="attach attachment connect link paperclip"></i>
                                        }
                                        {feedback.description}
                                    </b>
                            }
                        </p>

                        {/* mobile: chat activity */}
                        {feedback?.chats?.length > 0 && feedback.response_time !== null
                            ?
                                <>
                                    <span className='feedback-chat-activity' data-toggle="tooltip" data-placement="top" data-title={lastChat?.message} >
                                        {(lastChat?.user?.isBusiness === 1)
                                            ?
                                                <>
                                                    <span>{__('Last chat from Employee')}:&nbsp;</span>
                                                    <span>{lastChat?.user?.firstname}</span>
                                                </>
                                            :
                                                <>
                                                    <span>{__('Last chat from Customer')}:&nbsp;</span>
                                                    <span>{lastChat?.user?.firstname}</span>
                                                </>
                                        }
                                    </span>
                                </>
                            :
                            <span className='feedback-chat-activity'><span>{__('No chat activity')}</span></span>
                        }

                        {/* mobile: feedback time */}
                        <div className="d-flex">
                            <div>
                                <span>
                                    {feedback.priority === 30 ? this.state.timeSinceFeedBackStarted : ""}
                                </span>

                            </div>
                            <p className="feedback-card-v2-m-date ml-auto">{feedback.created_at}</p>
                        </div>
                    </div>
                </div>

                {/* Feedback row */}
                <div
                    className={"position-relative feedback-card-v2 priority mb-2 d-none d-xl-flex align-items-center cursor-pointer " + priorityClass}
                    data-priority={feedback.priority}
                    onClick={this.handleClick.bind(this)}
                >
                    {/* Submitted by */}
                    <div className='col-1 pl-0'>
                        <div className='row ml-0 mr-0'>
                            {this.props.state.title !== "More" && !this.props.state.isDashboard && (
                                <div className={'feedback-card-v2-label'}>
                                    <input type="checkbox"
                                        id={`feedback-checkbox-${feedback.id}`}
                                        style={{ width: "16px", height: "16px" }}
                                        className="feedback-card-v2-checkbox mr-2" onChange={this.updateChecked.bind(this)}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                        }}
                                        checked={this.props.state.checked_feedbacks.includes(feedback.id)} />
                                    <label className='cursor-pointer position-absolute top-0 h-100 mb-0' htmlFor={`feedback-checkbox-${feedback.id}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                        }} />
                                </div>
                            )}
                            <span className="feedback-card-v2-name">{feedback.name}</span>
                        </div>
                    </div>

                    {/* Department */}
                    { !this.props.state.isDashboard &&
                        (this.props.state.businessDepartmentCount > 0 || feedback?.referrer?.label?.length > 0) &&
                            <div className='col-1 pl-0'>
                                <div className='row ml-0 mr-1'>
                                    <span className="feedback-card-v2-department d-flex flex-column ml-0">
                                        <b>{feedback?.department?.split('/').join(' / ')}</b>
                                        {feedback?.referrer?.label?.length > 0 &&
                                            <>
                                                <span className='d-block'>{feedback?.referrer?.label}</span>
                                                <span className='d-block'>{feedback?.referrer?.link?.label}</span>
                                            </>
                                        }
                                    </span>
                                </div>
                            </div>
                    }

                    {/* IF Dashboard: Business location */}
                    {this.props.state.isDashboard &&
                        <>
                            {business_row_name}
                            {(this.props.state.businessDepartmentCount > 0 || feedback?.referrer?.label?.length > 0) &&
                                <span className='col-1 pl-0 pr-0 feedback-card-v2-department'>
                                    <span className='d-block'><b>{feedback.department}</b></span>
                                    {feedback?.referrer?.label?.length > 0 &&
                                        <span>
                                            <span className='d-block'>{feedback?.referrer?.label} </span>
                                            <span className='d-block'>{feedback?.referrer?.link?.label}</span>
                                        </span>
                                    }
                                </span>
                            }
                        </>
                    }


                    {/* status */}
                    <div className="col-1 pl-0 w-100 feedback-card-v2-badge text-center">
                        <span className={"badge badge-pill w-100 " + badgetype} id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            onClick={(event) => {
                                event.stopPropagation();
                            }}>{window.feedbackStatus[feedback.status].label}</span>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" onClick={(event) => {
                            event.stopPropagation();
                        }}>
                            <a className="dropdown-item" id={window.feedbackStatus.Open.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Open.label}</a>
                            <a className="dropdown-item" id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Pending.label}</a>
                            <a className="dropdown-item" id={window.feedbackStatus.Resolved.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.Resolved.label}</a>
                            {this.props.state.businessHasAutoPilot && feedback.ratethisbiz_rating && !feedback.description ? (<a className="dropdown-item" id={window.feedbackStatus.RatingsOnly.value} onClick={this.handleStatusClick.bind(this)} href="#">{window.feedbackStatus.RatingsOnly.label}</a>) : null}
                        </div>
                    </div>

                    {/* feedback title */}
                    <div className={this.props.state.isDashboard ? 'col-3 pl-0 feedback-card-v2-description-wrapper' : 'col-4 pl-0 feedback-card-v2-description-wrapper'}>
                        {/* check if feedback has attachment */}
                        {/* span used for spacing even if no icon */}
                        <span className="feedback-attachment-icon-holder">
                            {feedback.attachment_count > 0 &&
                                <i className="fas fa-paperclip feedback-icon-thin" data-search="attach attachment connect link paperclip" data-toggle="tooltip" data-placement="bottom" data-title={__('This Feedback contains an attachment')}
                                ></i>
                            }
                        </span>

                        {/* tooltip attributes set in JS after checking if needed */}
                        <span className="text-primary feedback-card-v2-description special-font"
                            data-title={feedback.description_notrim}
                            >
                            {feedback.description_notrim
                                ?
                                    <b className={`${priorityTextClass}`} dangerouslySetInnerHTML={{
                                        __html: feedback?.description_notrim?.replace(
                                            regex,
                                            '<span class="highlighted">$&</span>'
                                            )
                                        }}>
                                    </b>
                                :
                                (feedback.custom_qr_code?.custom_qr_form_id ? <span className='no-feedback-message'>{__("This user has submitted a form")}</span> :
                                    <span className='no-feedback-message'>{__("This user only left a rating")}</span>)
                            }
                        </span>
                    </div>

                    {/* chat activity */}
                    {/* show last chat activity or simply none */}
                    {(lastChat && lastChat.user)
                        ?
                            <>
                                <span className='col-1 pl-0 feedback-chat-activity' data-toggle="tooltip" data-placement="top" data-title={lastChat.message} >
                                    {lastChat.sender_id !== feedback.user.user_id
                                        ?
                                            <span>{__('Employee')}:</span>
                                        :
                                            <span>{__('Customer')}:</span>
                                    }
                                    <span>{UserHelper.getNameAndInitial(lastChat.user.firstname, lastChat.user.lastname)}</span>
                                </span>

                            </>
                        :
                            <>
                                <span className='col-1 pl-0 feedback-chat-activity' >
                                    <span>-</span>
                                </span>
                            </>
                    }

                    {/* requeste response */}
                    <span className="col-1 pl-0 feedback-card-v2-icons">{iconList}</span>

                    {/* time elapsed  */}
                    <span className='col-1 pl-0 feedback-card-v2-time' style={{ fontSize: "10px" }} data-toggle="tooltip" data-placement="bottom"
                        data-title={__('time elapsed since customer submitted Feedback (customer is still awaiting an initial chat response)')}>{feedback.priority === 30 ? this.state.timeSinceFeedBackStarted : ""}</span>

                    {/* satisfaction */}
                    <div className="col-1 pl-0 d-flex feedback-card-v2-smiley">{smileyrating}</div>

                    {/* created at - split by elements on diff rows*/}
                    <span className="col-1 pl-0 feedback-card-v2-date">
                        {createdAtElements?.length > 0 &&
                            <span className='feedback-card-created-at-wrapper'>
                                <span>{createdAtElements[0]}</span>
                                <span>{createdAtElements[1]} {createdAtElements[2]}</span>
                                <span>{createdAtElements[3]}</span>
                            </span>
                        }
                    </span>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(Feedback);
